import type { UserDoc } from '@astrally/shared';

/**
 * Decides which profile wins when someone finishes onboarding.
 *
 * Extracted so the rule is testable without Firebase, because getting it wrong
 * is not a cosmetic bug: onboarding always builds a fresh UserDoc from the
 * form, and writing that over a RETURNING account's profile would reset their
 * display name and intents. Firestore refuses it outright — the users/{uid}
 * update rule pins socialEnabled, discoverable and socialConsentAtISO to their
 * stored values, since only the socialSetEnabled function may change them — so
 * a returning user with connections switched on saw a bare permission-denied
 * and could not sign in at all.
 */
export function resolveOnboardingUser(
  existing: UserDoc | null,
  fromForm: UserDoc,
  uid: string,
): { user: UserDoc; mustSave: boolean } {
  // The server's copy is authoritative and already carries consent state the
  // client is not allowed to author.
  if (existing) return { user: existing, mustSave: false };
  return { user: { ...fromForm, uid }, mustSave: true };
}
